module.exports = __webpack_public_path__ + "assets/img/lock.030e47fc.svg";